import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import {
  selectFirestopImagesToAdd,
  selectFirestopItemsToCreate,
  selectSelectedFirestopListId,
} from '../selectors/firestop-documentation.selectors';
import { postCreateNewFirestops } from '../services/post-create-new-firestops.service';
import {
  closeAddMultipleFirestopLocationsDialog,
  closeAddNewFirestopsDialog,
} from '../actions/firestop-documentation.actions';

export const createNewFirestops = createAsyncThunk(
  'firestopDocumentation/createNewFirestops',
  async (options, { getState, dispatch }) => {
    const { origin = 'single' } = options || {};

    const selectedProjectId = selectSelectedProjectId(getState());
    const selectedFirestopListId = selectSelectedFirestopListId(getState());
    const firestopItemsToCreate = selectFirestopItemsToCreate(getState());

    const firestopImagesToAdd = selectFirestopImagesToAdd(getState());

    const createdListData = await postCreateNewFirestops(
      selectedProjectId,
      selectedFirestopListId,
      Object.values(firestopItemsToCreate),
      firestopImagesToAdd
    );

    if (origin === 'multipleLocations') {
      dispatch(closeAddMultipleFirestopLocationsDialog());
    } else {
      dispatch(closeAddNewFirestopsDialog());
    }

    return createdListData;
  }
);
